import {
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  Inject,
  Input, OnChanges,
  OnDestroy,
  OnInit, SimpleChanges,
  ViewContainerRef
} from '@angular/core';
import {NgControl} from '@angular/forms';
import {Subscription} from 'rxjs';
import {InjectionToken} from '@angular/core';
import {ControlErrorsComponent} from '../components/control-errors/control-errors.component';
import {ErrorsType} from '../models/errors-type';
import {IpGatewayValidatorService} from '../../order/services/ip-validator-gateway.service';

export const defaultErrors = {
  required: (error) => `wrong`,
  pattern: (error) => `wrong`,
  max: ({max, actual}) => `wrong`,
  min: ({min, actual}) => `wrong`,
  minlength: ({requiredLength, actualLength}) => `wrong`,
  maxlength: ({requiredLength, actualLength}) => `wrong`,
  duplicate: (error) => `wrong`,
};

export const FORM_ERRORS = new InjectionToken('FORM_ERRORS', {
  providedIn: 'root',
  factory: () => defaultErrors
});

@Directive({
  // tslint:disable:directive-selector
  selector: '[ctrl-error]'
})
export class ControlErrorsDirective implements OnInit, OnDestroy, OnChanges {

  refError: ComponentRef<ControlErrorsComponent>;
  container: ViewContainerRef;
  sub$: Subscription;
  @Input() customErrors = {};
  @Input() isDuplicate: boolean;
  @Input() error: boolean;


  constructor(private resolver: ComponentFactoryResolver,
              private vcr: ViewContainerRef,
              private control: NgControl,
              private ipGatewayValidatorService: IpGatewayValidatorService,
              @Inject(FORM_ERRORS) private errors: ErrorsType) {
  }

  ngOnInit(): void {
    this.sub$ = this.control.valueChanges.subscribe(() => {

      const controlErrors = this.control.errors;
      if (this.control.enabled  && this.control.value && this.control.value !== 'Invalid date') {
        if (controlErrors) {
          const firstKey = Object.keys(controlErrors)[0];
          const getError = this.errors[firstKey];

          const text = getError(controlErrors[firstKey]);
          this.setError(text);
        } else {
          // TODO: Update this 'if' for more generic
          if (this.ipGatewayValidatorService.getResult() !== false ||
            ((this.control.name !== 'ip') && ( this.control.name !== 'gateway')  && (this.control.name !== 'mask')) ) {
            this.setError('wright');
          }

        }
      } else {
        this.setError('none');
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isDuplicate && changes.isDuplicate.currentValue) {
      this.setError('none');
    }
    if (changes.error && changes.error.currentValue) {
      if (changes.error.currentValue) {
        this.setError('wrong');
      } else {
        this.setError('wright');
      }
    }
  }

  ngOnDestroy(): void {
    if (this.sub$) {
      this.sub$.unsubscribe()
    }
  }

  setError(text: string): void {
    if (!this.refError) {
      const factory = this.resolver.resolveComponentFactory<ControlErrorsComponent>(ControlErrorsComponent);
      this.refError = this.vcr.createComponent(factory);
    }
    this.refError.instance.text = text;
  }
}
